<template>
    <div class="mx-2">
        <div class="col-md-12 d-flex mx-2 align-items-end mt-3">
            <div class="me-2">
                <i class="bi bi-card-checklist display-3"></i>
            </div>
            <div>
                <p class="mb-0 reducirTamaño text-secondary">
                    001
                </p>
                <p class="mb-2 tituloResaltado">BUSQUEDA DE INFORMACION</p>
            </div>
        </div>

        <button class="ms-3 btn btn-success" @click="descargarExcel" :disabled="excelCarga">
            <i class="bi bi-filetype-xls"></i>
            <b v-if="excelCarga">cargando...</b>
        </button>

        <abbr title="RECARGA DE REPORTE">
            <button @click="reporte" class="btn btn-ligth border border-1 text-primary ms-1">
                <i class="bi bi-arrow-counterclockwise"></i>
            </button>
        </abbr>



        <div class="d-flex border-bottom mt-2 px-3">
            <div class="me-4 py-2" :class="activeTab === 'buscando'
                ? 'fw-bold border-bottom border-primary text-primary'
                : 'text-muted'
                " style="cursor: pointer"
                @click="(activeTab = 'buscando'), busqueda = '' , getAttributesCitasPostulante(1), categoria = 1, reporte(), excelCarga = true">
                EN PROCESO DE POSTULACION
            </div>
            <div class="py-2" :class="activeTab === 'resumen'
                ? 'fw-bold border-bottom border-primary text-primary'
                : 'text-muted'
                " style="cursor: pointer"
                @click="(activeTab = 'resumen'), busqueda= '' , getAttributesCitasPostulante(2), categoria = 2, reporte(), excelCarga = true">
                SELECCIONADOS
            </div>
        </div>
        <div class="d-flex justify-content-end mt-2">
            <span for="" class="input-group-text mt-3 buscar-estiloCuadrado">
                <i class="bi bi-search"></i></span>
            <input class="form-control form-control-lg w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
                aria-label=".form-control-lg example" placeholder="POR SOLICITUD / SCC / ESTADO /ASIGNADO"
                v-model="busqueda" @input="BuscadorCitasMedicas({ busqueda: busqueda || '', categoria })" />
        </div>

        <div v-if="LoaderCitasMedicas" class="d-flex justify-content-center align-items-center" style="height: 60vh">
            <SpinnerCarga />
        </div>

        <div v-else class="table-responsive mx-2 mt-2">
            <table class="table table-bordered">
                <thead class="reducirTamaño">
                    <tr class="bg-solimano text-white text-center text-nowrap">
                        <th style="text-align: center">RQ</th>
                        <th style="text-align: center">POSTULANTE</th>
                        <th style="text-align: center">DATOS PERSONALES</th>
                        <th style="text-align: center">FEC. REGISTRO</th>
                        <th style="text-align: center">POSTULACION</th>
                        <th style="text-align: center">ESTADO DEL POSTULANTE</th>
                        <th style="text-align: center">COMENTARIO</th>
                        <th v-if="isAdmin" style="text-align: center">OBSERVACION</th>
                        <th style="text-align: center">CITA MEDICA</th>
                        <th style="text-align: center">ACCIONES</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- v-for=""
              :key="index.id" -->
                    <tr v-for="cita in paginatedCitas" :key="cita.id"
                        class="text-center align-middle reducirTamaño text-nowrap tabla-estiloCompreso">

                        <td class="align-middle text-center">
                            <span class="badge bg-primary">{{ cita.nroReq }}</span>
                        </td>

                        <td class="text-start ">
                            <strong class="text-dark d-block">{{ cita.nomPostulante }}</strong>
                            <small class="text-muted d-block">{{ cita.posGenero }}</small>
                            <span class="fw-semibold text-secondary d-block">{{ cita.posDocIdentidad }}</span>
                        </td>

                        <td class="text-start ">
                            <i class="bi bi-cake text-danger me-1"></i>
                            <strong>F. Nac: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.posFecNacimiento }}</span><br />

                            <i class="bi bi-envelope text-primary me-1"></i>
                            <strong>Correo: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.correo }}</span><br />

                            <i class="bi bi-telephone text-success me-1"></i>
                            <strong>Tel.: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.postelefono }}</span>
                        </td>

                        <td class="text-center">
                            <small>{{ cita.fecRegistro }}</small>
                        </td>

                        <td class="text-start ">
                            <i class="bi bi-briefcase-fill text-primary me-1"></i>
                            <strong>Puesto: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.puesto }}</span><br />

                            <i class="bi bi-geo-alt-fill text-danger me-1"></i>
                            <strong>Lugar: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.ubigeo }}</span><br />

                            <i class="bi bi-building-fill text-info me-1"></i>
                            <strong>Cliente: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.cliente }}</span><br />

                            <span :class="{
                                'text-danger fw-bold': cita.solcampana === 'CAMPAÑA',
                                'text-success fw-semibold': cita.solcampana !== 'CAMPAÑA'
                            }">
                                {{ cita.solcampana }}
                            </span>
                        </td>

                        <td class="text-center fw-bold tabla-estiloCompreso">
                            <label for="" :class="{
                                'text-success':
                                    cita.estado_del_postulante == 'APTO' ||
                                    cita.estado_del_postulante == 'SELECCIONADO',
                                'text-primary':
                                    cita.estado_del_postulante == 'EN PROCESO DE EVALUACION',
                                'text-danger':
                                    cita.estado_del_postulante == 'NO APTO' ||
                                    cita.estado_del_postulante == 'OBSERVADO' ||
                                    cita.estado_del_postulante == 'APTO CON RESTRICCIONES',
                                'text-warning':
                                    cita.estado_del_postulante == 'PROGRAMAR EMPO',
                            }">{{ cita.estado_del_postulante }}</label>
                        </td>
                        <td class="text-start tabla-estiloCompreso">
                            <label>{{ cita.comentario }}</label>
                        </td>
                        <td v-if="isAdmin"  class="text-start tabla-estiloCompreso">{{ cita.observacion }}</td>

                        <td class="text-start">
                            <i class="bi bi-geo-alt-fill text-danger me-1"></i>
                            <strong class="text-dark">Sede: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.nomSede }}</span><br />

                            <i class="bi bi-clipboard-check text-primary me-1"></i>
                            <strong class="text-dark">Protocolo: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.protocolo }}</span><br />

                            <i class="bi bi-cash-coin text-success me-1"></i>
                            <strong class="text-dark">Liquidación: </strong>
                            <span class="text-secondary fw-semibold">{{ cita.liquidacion }}</span><br />

                            <i class="bi bi-calendar-check text-warning me-1"></i>
                            <strong class="text-dark">Cita: </strong>
                            <input :value="cita.fechaAtencion" type="datetime-local" disabled
                                class="text-start border border-0 ms-1 bg-white px-0 mx-0" />
                        </td>

                        <td>   
                            <div class="d-flex">    
                                <button :disabled="cita.fechaAtencion.slice(0,10) != '1900-01-01'" @click="MandarData(cita)" v-b-modal.modal-center
                                    class="btn btn-outline-success boton-estiloCuadrado">
                                    <i class="bi bi-floppy"></i>
                                </button>

                                <button :disabled="cita.fechaAtencion.slice(0,10) == '1900-01-01'" @click="MandarData(cita)" v-b-modal.modal-center
                                    class="btn btn-outline-warning boton-estiloCuadrado">
                                    <i class="bi bi-pencil"></i>
                                </button>

                                <button v-if="isAdmin" :disabled="cita.fechaAtencion.slice(0,10) == '1900-01-01'" class="btn btn-ligth boton-estiloCuadrado" @click="MandarData(cita)"
                                    v-b-modal.modal-center1>
                                    <i class="bi bi-activity"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- insertar -->
            <div>
                <!-- 🟩 MODAL PRINCIPAL -->
                <b-modal id="modal-center" centered hide-footer
                    :title="fechaTabla.slice(0,10) == '1900-01-01' ? '➕ INSERTAR CAMPOS' : '✏️ EDITAR CAMPOS'"
                    title-class="fw-semibold text-primary">
                    <div class="p-3">
                        <!-- SEDE -->
                        <label class="form-label fw-semibold text-dark mb-1">
                            <i class="bi bi-geo-alt-fill text-danger me-1"></i> Nombre de Sede:
                        </label>
                        <select class="form-select form-select-sm shadow-sm mb-3" aria-label="Seleccionar sede" @change="sedeTemp = JSON.parse($event.target.value);
                        codSede = sedeTemp.parCorrelativo;
                        nombreSede = sedeTemp.parDescripcion;
                        dirSede = sedeTemp.parCadAlterno1">
                            <option v-if="crea != ''" selected value="">{{ nombreSede }}</option>
                            <option v-if="crea == ''" selected value="">-- SELECCIONAR SEDE --</option>
                            <option v-for="sede in Sedes" :key="sede.id" :value="JSON.stringify(sede)">
                                {{ sede.parDescripcion }}
                            </option>
                        </select>

                        <!-- PROTOCOLO -->
                        <label class="form-label fw-semibold text-dark mb-1">
                            <i class="bi bi-file-earmark-text-fill text-primary me-1"></i> Protocolo:
                        </label>
                        <input v-model="protocolo" type="text" class="form-control form-control-sm shadow-sm mb-3"
                            placeholder="Ingrese protocolo" />

                        <!-- LIQUIDACIÓN -->
                        <label class="form-label fw-semibold text-dark mb-1">
                            <i class="bi bi-cash-stack text-success me-1"></i> Liquidación:
                        </label>
                        <input v-model="liquidacion" type="text" class="form-control form-control-sm shadow-sm mb-3"
                            placeholder="Ingrese liquidación" />

                        <!-- FECHA -->
                        <label class="form-label fw-semibold text-dark mb-1">
                            <i class="bi bi-calendar-date-fill text-warning me-1"></i> Fecha:
                        </label>
                        <input required v-model="fecha" type="datetime-local"
                            class="form-control form-control-sm shadow-sm" :min="fechaDeAhora" />

                        <!-- BOTONES -->
                        <div class="text-center mt-4">
                            <button v-if="fechaTabla.slice(0,10) == '1900-01-01'" @click="GuardarData()" class="btn btn-outline-success btn-sm mx-2"
                                title="Guardar nuevo registro">
                                <i class="bi bi-floppy2-fill fs-5 "></i>
                            </button>

                            <button v-if="fechaTabla.slice(0,10) != '1900-01-01'" @click="EditarData()"
                                class="btn btn-outline-secondary btn-sm mx-2" title="Actualizar registro">
                                <i class="bi bi-pencil-square fs-5 "></i>
                            </button>
                        </div>
                    </div>
                </b-modal>

                <!-- 🟨 MODAL DE OBSERVACIÓN -->
                <b-modal id="modal-center1" centered hide-footer title="🗒️ OBSERVACIÓN"
                    title-class="fw-semibold text-primary">
                    <div class="p-3">
                        <label class="form-label fw-semibold text-dark mb-2">
                            <i class="bi bi-chat-dots-fill text-info me-1"></i> Escriba su observación:
                        </label>

                        <b-form-textarea id="textarea" v-model="observacion"
                            placeholder="Ingrese su observación aquí..." rows="4" max-rows="6"
                            class="shadow-sm"></b-form-textarea>

                        <div class="text-center mt-4">
                            <button @click="EditarObservacion()" class="btn btn-outline-secondary btn-sm"
                                title="Guardar observación">
                                <i class="bi bi-floppy2-fill fs-5 "></i>
                            </button>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
        <!-- Paginado -->
        <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
            </button>
            <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
            </button>
            <span class="pagination-info">Página {{ currentPage }} de {{ totalPages }}</span>
            <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
            </button>
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SpinnerCarga from "@/components/SpinnerCarga.vue/SpinnerCarga.vue";
import Swal from "sweetalert2";
export default {
    name: "CopiasCitaMedica",
    components: {
        SpinnerCarga,
    },

    data() {
        return {
            nombreSede: "",
            protocolo: "",
            liquidacion: "",
            fecha: Date,
            codSede: "",
            crea: "",
            idSolXPostulante: "",
            Sedes: [],
            currentPage: 1,
            pageSize: 10,
            fechaDeAhora: null,
            busqueda: "",
            activeTab: "busqueda", // valor inicial
            codUbigeo: "",
            nombre: "",
            NroReq: "",
            puesto: "",
            estado: "",
            dirSede: "",
            mapSede: "",
            observacion: "",
            excel: null,
            categoria: "1",
            excelCarga: true,
            abortController: null, // 👈 controlador de cancelación
            fechaTabla:""

        };
    },

    mounted() {
        this.axios.get(`ParametroData/Parametro/7847`).then((r) => {
            console.log(r.data);
            this.Sedes = r.data;
        });

        const tiempoTranscurrido = Date.now();
        const hoy = new Date(tiempoTranscurrido);
        this.fechaDeAhora = hoy.toISOString().slice(0, 10);
    },

    created() {
        this.cambiarEstadoNavbar();
        this.reporte()
    },

    computed: {
        ...mapGetters("listadoPostulante", ["Citas", "LoaderCitasMedicas"]),
        totalPages() {
            return Math.ceil(this.Citas.length / this.pageSize);
        },

        paginatedCitas() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.Citas.slice(start, start + this.pageSize);
        },

       isAdmin() {
        const userId = localStorage.getItem('userId');
        return userId == 9082 || userId == 16114;
        },
    },
    methods: {
        ...mapActions("listadoPostulante", [
            "getAttributesCitasPostulante",
            "BuscadorCitasMedicas",
        ]),

        reporte() {
            this.excelCarga = true
            this.excel = null
            const idTrabajador = localStorage.getItem("idTrabajdor");
            const categoria = this.categoria

            //  Si ya hay una solicitud en curso, cancélala
            if (this.abortController) {
                this.abortController.abort();
            }

            this.abortController = new AbortController();


            this.axios
                .get("ReportesExcel/ReporteCitaMedica", {
                    params: { idTrabajador, categoria },
                    responseType: "blob", signal: this.abortController.signal, // usa la señal
                })
                .then((response) => {
                    this.excel = response.data;
                    this.excelCarga = false
                    console.log("respuesta", response.data);
                }).catch((error) => {
                    if (error.name === "CanceledError") {
                        console.log("Solicitud anterior cancelada");
                    } else {
                        console.error("Error al descargar el reporte:", error);
                    }
                })
                .finally(() => {
                    this.excelCarga = false;
                });
        },

        descargarExcel() {
            var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "ReporteCitaMedica.xlsx");
            document.body.appendChild(fileLink);

            fileLink.click();
            document.body.removeChild(fileLink);

        },

        cambiarEstadoNavbar() {
            // Acción directa para cambiar el estado del navbar a true
            this.$store.dispatch("acciones/CambioNavbar", true);
        },

        // BuscadorCitasMedicas() {
        //   if (this.busqueda.trim() === "") {
        //     // Si está vacío, carga todo
        //     this.getAttributesCitasPostulante();
        //   } else {
        //     // Sino filtra con lo que hay en el input
        //     this.BuscadorCitasMedicas(this.busqueda);
        //   }
        // },

        GuardarData() {
            // parCodigo = 079
            const from = {
                codSede: this.codSede,
                protocolo: this.protocolo,
                liquidacion: this.liquidacion,
                idSolXPostulante: this.idSolXPostulante,
                fecAtencion: this.fecha,
                idUsuario: parseInt(localStorage.getItem("userId")), // 👈 Este es el nombre correcto
            };
            console.log(from);
            this.axios
                .post(`SolicitudData/RegistrarCitaMedica`, from)
                .then((r) => {
                    console.log(r.data);
                    if (r.data) {
                        this.getAttributesCitasPostulante(this.categoria).then(async () => {
                            if (this.busqueda && this.busqueda.trim() !== "") {
                                await this.BuscadorCitasMedicas({ busqueda: this.busqueda, categoria: this.categoria });
                            }
                            this.MandarCorreo(this.idSolXPostulante);
                     });

                        this.$bvModal.hide("modal-center");
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se realizo tus cambios",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        
        EditarData() {
            const from = {
                codSede: this.codSede,
                protocolo: this.protocolo,
                liquidacion: this.liquidacion,
                idSolXPostulante: this.idSolXPostulante,
                fecAtencion: this.fecha,
                observacion: this.observacion,
                idUsuario: parseInt(localStorage.getItem("userId")), // 👈 Este es el nombre correcto
            };
            console.log(from);
            this.axios
                .put(`SolicitudData/ActualizarCitaMedica`, from)
                .then((r) => {
                    if (r.data) {
                        this.getAttributesCitasPostulante(this.categoria).then(async () => {
                            if (this.busqueda && this.busqueda.trim() !== "") {
                                await this.BuscadorCitasMedicas({ busqueda: this.busqueda, categoria: this.categoria });
                            }
                            if (this.liquidacion.length == 0) {
                                this.MandarCorreo(this.idSolXPostulante);
                            }
                        });
                        this.$bvModal.hide("modal-center");
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se realizo tus cambios",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },

        EditarObservacion(){
            const from = {
                codSede: this.codSede,
                protocolo: this.protocolo,
                liquidacion: this.liquidacion,
                idSolXPostulante: this.idSolXPostulante,
                fecAtencion: this.fecha,
                observacion: this.observacion,
                idUsuario: parseInt(localStorage.getItem("userId")), // 👈 Este es el nombre correcto
            };
            console.log(from);
            this.axios
                .put(`SolicitudData/ActualizarCitaMedica`, from)
                .then((r) => {
                    if (r.data) {
                        this.getAttributesCitasPostulante(this.categoria).then(async () => {
                            if (this.busqueda && this.busqueda.trim() !== "") {
                                await this.BuscadorCitasMedicas({ busqueda: this.busqueda, categoria: this.categoria });
                            }
                        });
                        this.$bvModal.hide("modal-center");
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se realizo tus cambios",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },

        MandarCorreo(idSol) {
            this.axios
                .get(`Tecnologia/ObtenerCorreosActividad`, {
                    params: {
                        actividad: "002",
                        ubigeo: this.codUbigeo,
                    },
                })
                .then((r) => {
                    if (!r.data || r.data.length === 0) return;
                    let CorreosCopia = r.data[0].correo;
                    console.log(CorreosCopia)

                    for(let c of this.Citas){
                        console.log('Buscando en Citas:', c.idSolXPostulante, 'ID buscado:', idSol);
                        if(Number(c.idSolXPostulante) == Number(idSol)){
                            console.log('Registro encontrado en la lista:', c);
                         this.axios.post("Tecnologia/CorreoConfirmacionCita", {
                              CorreoDestino: this.correoPersonal,
                              CorreosCopia: CorreosCopia,
                              NumeroRQ: this.NroReq,
                              Nombres: this.nombre,
                              Sede: c.nomSede,
                              Dirección: this.dirSede,
                              Ubicación: c.mapSede,
                              Ubigeo: this.nomUbigeo,
                              Fecha: this.fecha ? this.fecha.slice(0, 10) : "",
                              Hora: this.fecha ? this.fecha.slice(11, 16) : "",
                              Puesto: this.puesto,
                              NomEmpresa: this.empresa
                        //     // Estado: this.estado
                        }
                        )
                            .then(res => {
                                alert("✅ Correo enviado", res);
                            })
                            .catch(err => {
                                console.error("❌ Error:", err);
                                alert("❌ Error al enviar correo");
                            });   
                        }
                    }

                        
                    
                  
                });
        },

        MandarData(data) {
            console.log(data);
            this.fechaTabla = data.fechaAtencion
            this.crea = data.crea;
            this.nombreSede = data.nomSede;
            this.protocolo = data.protocolo;
            this.liquidacion = data.liquidacion;
            this.fecha = data.fechaAtencion;
            this.idSolXPostulante = data.idSolXPostulante;
            this.codUbigeo = data.codUbigeo;
            this.nombre = data.nomPostulante;
            this.NroReq = data.nroReq;
            this.nomUbigeo = data.ubigeo
            this.puesto = data.puesto
            this.estado = data.estado_del_postulante
            this.dirSede = data.dirSede
            this.mapSede = data.mapSede
            this.empresa = data.nomEmpresa
            this.correoPersonal = data.correo
            this.observacion = data.observacion
            this.codSede = data.codSede
        },
    },
};
</script>


<style scoped>
.boton-estiloCuadrado {
    padding: 0.2rem 0.55rem;
    cursor: pointer;
}

.buscar-estiloCuadrado {
    border-radius: 0;
    font-size: 0.65rem;
    background-color: transparent;
    /* Fondo transparente */
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

.input-group {
    max-width: 350px;
}

.row.mb-3 {
    margin-bottom: 1rem !important;
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

.reducirTamaño {
    font-size: 0.65rem;
}

.bg-solimano {
    background: #1565c0;
}

.bg-solimano-table {
    background: #0080c8;
}

.btn-solimano {
    background: #0080c8;
}

.tamaño {
    font-size: 0.65rem;

    font-weight: 800;
    color: #002c5d;
}

table,
tr,
h6 {
    page-break-inside: avoid;
}
</style>
